import React from "react";
import { motion } from "framer-motion";
import { Star, Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const TestimonialsPreview = ({ testimonials }) => {
  const testimonialItems = Array.isArray(testimonials) ? testimonials : [];
  if (testimonialItems.length === 0) return null;

  return (
    <section className="py-24 bg-[#F6F7F1]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-16 bg-[#D4AF37]" />
            <Sparkles className="w-5 h-5 text-[#D4AF37]" />
            <div className="h-px w-16 bg-[#D4AF37]" />
          </div>
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Ce que disent nos clients
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonialItems.map((t, index) => {
            const parsedRating = Number(t.rating);
            const rating = Number.isFinite(parsedRating)
              ? Math.min(5, Math.max(1, Math.floor(parsedRating)))
              : 5;
            return (
            <motion.div
              key={t.id || `testimonial-${index}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="bg-white rounded-2xl p-8 relative shadow-sm"
            >
              <div className="absolute top-4 right-6 text-6xl font-serif text-[#E5007D]/10 leading-none">"</div>
              <div className="flex gap-1 mb-4">
                {Array.from({ length: rating }, (_, i) => (
                  <Star key={`star-${t.id || index}-${i}`} className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" />
                ))}
              </div>
              <p className="text-gray-600 mb-6 leading-relaxed text-sm">{t.text}</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#E5007D] flex items-center justify-center text-white font-bold text-sm">
                  {t.name ? t.name.charAt(0) : "C"}
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{t.name || "Client"}</p>
                  <p className="text-xs text-gray-500">{t.event || "Événement"} - {t.date || "Récemment"}</p>
                </div>
              </div>
            </motion.div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <Link to="/avis" className="inline-flex items-center gap-2 text-[#E5007D] font-medium text-sm hover:underline">
            Lire tous les avis
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsPreview;
